import { BucketingManager } from './BucketingManager';
export class EdgeManager extends BucketingManager {
    getCampaignsAsync(visitor) {
        return super.getCampaignsAsync(visitor);
    }
}
